module.exports = __webpack_public_path__ + "media/images/expand-8f0f992d6b518da626624d4176cb6d2c.png";